import { render, staticRenderFns } from "./SaleNoteActions.vue?vue&type=template&id=4b9d23a0&scoped=true&"
import script from "./SaleNoteActions.vue?vue&type=script&lang=js&"
export * from "./SaleNoteActions.vue?vue&type=script&lang=js&"
import style0 from "./SaleNoteActions.vue?vue&type=style&index=0&id=4b9d23a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9d23a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b9d23a0')) {
      api.createRecord('4b9d23a0', component.options)
    } else {
      api.reload('4b9d23a0', component.options)
    }
    module.hot.accept("./SaleNoteActions.vue?vue&type=template&id=4b9d23a0&scoped=true&", function () {
      api.rerender('4b9d23a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Invoices/History/SaleNoteActions.vue"
export default component.exports